import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { CompanyLicenseInformation } from '../../types/CompanyLicenseInformation';
import { LicenseMainFormBaseDataProvider } from '../dataProvider/LicenseMainFormBaseDataProvider';
import { LicenseMainFormDataProviderFactory } from '../factory/LicenseMainFormDataProviderFactory';

export class LicenseMainFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: LicenseMainFormDataProviderFactory;
  public dataProvider: LicenseMainFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new LicenseMainFormDataProviderFactory(),
    });
  }

  public async getCompanyLicenseInformation(editedCompanyId?: string | null): Promise<CompanyLicenseInformation> {
    return this.dataProvider.getCompanyLicenseInformation(editedCompanyId);
  }
}
